import { ServiceIdEnum } from './consultant';

export enum ProfileServiceType {
  DOCTOR = 1,
  CLINIC = 2,
}

export type GetProfileServicePayload = {
  id: number;
  profileType: ProfileServiceType;
};

export type GetProfileServicesDataModel = {
  isEnabled: boolean;
  profileId: number;
  servicePresentationId: ServiceIdEnum;
};

export type GetProfileServicesAdressesDataModel = {
  recId: number;
  profileId: number;
  title: string;
  cityId: number;
  regionName: string | null;
  address: string;
  latitude: number;
  longitude: number;
  regionId: string | null;
  cityName: string;
  phoneNumber: string | null;
};

export type GetProfileServicesSpecialityDataModel = {
  specialtyId: number;
  specialtyTitle: string;
  profileId: number;
  shortTitle: string | null;
};

export type GetProfileServicesInsuranceDataModel = {
  insuranceId: number;
  insuranceTitle: string;
  profileId: number;
};

export type GetProfileServicesAvailableVisitServicesDataModel = {
  serviceId: number;
  serviceName: string;
  firstServiceDate: string;
  firstServiceTime: string;
};

export type GetProfileServicesAttributesDataModel = {
  medicalRegistrationNumber: number;
  doctorExperienceDate: number;
  educationLevel: string;
  systemType: number;
};

export type GetProfileServiceResponse = {
  recId: number;
  ownerId: number;
  profileType: number;
  hasSchedule: boolean;
  basicInfo: {
    fullName: string;
    description: string;
    coverImageUrl: string;
    aboutDoctor: string;
    rate: number;
  };
  addresses: GetProfileServicesAdressesDataModel[];
  servicePresentations: GetProfileServicesDataModel[];
  specialties: GetProfileServicesSpecialityDataModel[];
  insurances: GetProfileServicesInsuranceDataModel[];
  attributes: GetProfileServicesAttributesDataModel;
  availableVisitServices:
    | GetProfileServicesAvailableVisitServicesDataModel[]
    | null;
};

export enum InsuranceTypeEnum {
  Basic = 1,
  Supplementary = 2,
}

export type GetUserInsurancePayload = {
  id: number;
  pageNumber: number;
  pageSize: number;
  insuranceType?: InsuranceTypeEnum;
};

export type GetUserInsuranceItemModel = {
  createdAt: string;
  id: number;
  insuranceId: number;
  insuranceName: string;
  insuranceTypeId: number;
  insuranceTypeName: string;
  isActive: boolean;
  imageUrl: string;
};

export type GetUserInsuranceResponse = {
  pageNumber: number;
  pageSize: number;
  totalCount: number;
  queryResult: GetUserInsuranceItemModel[];
};

export type GetProfileServicePlacePayload = {
  id: number;
  InsuranceType?: InsuranceTypeEnum;
};

export type GetProfileServicePlaceResponse = {};

export type GetUserServiceByDoctorIdPayload = {
  id: number;
  pageNumber: number;
  pageSize: number;
};

export type GetUserServiceByDoctorIdItemModel = {
  createdAt: string;
  deposit: number;
  description: string | null;
  discountPercent: number;
  discountPrice: number;
  finalPrice: number;
  id: number;
  imageURL: string;
  isActive: boolean;
  price: number;
  serviceHierarchyId: number;
  serviceHierarchyName: string;
  totalPrice: number;
  profileId: number;
};

export type GetUserServiceByDoctorIdResponse = {
  pageNumber: number;
  pageSize: number;
  totalCount: number;
  queryResult: GetUserServiceByDoctorIdItemModel[];
};
